export const EDITABLE_STATUS = [
  "Approved",
  "Approved - Pending MarOps Review",
  "Launched",
  "Submitted",
  "Rejected",
];
